import React, { useEffect } from "react";
import { NavLink, useParams, useHistory, Switch } from "react-router-dom";
import OverviewContainer from "@icoach/members/overview/OverviewContainer";
import PrivateRoute from "@common/components/route/PrivateRoute";
import { Icons, Tabs, Tab, Box } from "@curves/ui-base";
import { CLUB_MEMBERS_ROUTER } from "@icoach/router/routerPath";
import { RentCabinetPage } from "@icoach/rentCabinet/";
import SmartFitnessBandPage from "@icoach/smartFitnessBand/SmartFitnessBandPage";
import { GiftManagementPage } from "@icoach/gift/";
import { MEMBERS_OVERVIEW_TABS, MEMBERS_TABS } from "@icoach/constants/";
import { isEqual } from "@util/utils";

const MembersTabsHeader = props => {
	const { value: propsValue, handleTabsValue = () => {} } = props;

	const handleChange = (event, newValue) => {
		handleTabsValue && handleTabsValue(newValue);
	};

	return (
		<Box className="members-tabs page-tabs tabs-bottom-line">
			<Tabs value={propsValue} onChange={handleChange} variant="scrollable" allowScrollButtonsMobile>
				<Tab
					className="py-3"
					label="會員總覽"
					icon={<Icons.UserCircle />}
					value={MEMBERS_TABS.MEMBER_OVERVIEW}
					component={NavLink}
					to={CLUB_MEMBERS_ROUTER.MEMBER_OVERVIEW.GET_TABS_PATH(MEMBERS_TABS.MEMBER_OVERVIEW)}
				/>
				<Tab className="py-3" label="贈品管理" icon={<Icons.GiftSolid />} value={MEMBERS_TABS.GIFT} component={NavLink} to={CLUB_MEMBERS_ROUTER.GIFT.GET_TABS_PATH("overview")} />
				<Tab className="py-3" label="租櫃管理" icon={<Icons.Inbox />} value={MEMBERS_TABS.RENT_CABINET} component={NavLink} to={CLUB_MEMBERS_ROUTER.CABINET.GET_TABS_PATH("document")} />
				<Tab
					className="py-3"
					label="智能系統"
					icon={<Icons.Ring />}
					value={MEMBERS_TABS.SMARTFITNESSBAND}
					component={NavLink}
					to={CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.GET_TABS_PATH("overview")}
				/>
			</Tabs>
		</Box>
	);
};

const MembersPage = () => {
	const { tabs } = useParams();
	const history = useHistory();

	useEffect(
		() => {
			if (isEqual(tabs, MEMBERS_TABS.MEMBER_OVERVIEW)) {
				const splitPaths = history.location.pathname.split("/").filter(el => el);
				const lastPath = splitPaths[splitPaths.length - 1];
				if (isEqual(lastPath, tabs)) history.push(CLUB_MEMBERS_ROUTER.MEMBER_OVERVIEW.GET_TABS_PATH(MEMBERS_OVERVIEW_TABS.NORMAL));
			}
		},
		// eslint-disable-next-line
		[history.location]
	);

	return (
		<React.Fragment>
			{tabs && (
				<Box className="container main-container-spacing members-container">
					<MembersTabsHeader value={tabs} />
					<Switch>
						<PrivateRoute exact path={CLUB_MEMBERS_ROUTER.MEMBER_OVERVIEW.NORMAL_PAGE} as={OverviewContainer} />
						<PrivateRoute exact path={CLUB_MEMBERS_ROUTER.MEMBER_OVERVIEW.QUICK_PAGE} as={OverviewContainer} />
						<PrivateRoute exact path={CLUB_MEMBERS_ROUTER.GIFT.PAGE} as={GiftManagementPage} />
						<PrivateRoute exact path={CLUB_MEMBERS_ROUTER.CABINET.PAGE} as={RentCabinetPage} />
						<PrivateRoute exact path={CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.PAGE} as={SmartFitnessBandPage} />
					</Switch>
				</Box>
			)}
		</React.Fragment>
	);
};

export default MembersPage;
